import { makeReducer } from "../../core/make-reducer";
import ViewerMethod from "../../core/ViewerMethod";
import { BaseFigure, FigureRawData } from "./types";
import { generateUUID } from "../../../../../../common/utils/uuid";

export default makeReducer(
  ViewerMethod.GET_FIGURES,
  (data: FigureRawData[]): BaseFigure[] => {
    return data.map((fig) => ({ ...fig, figureId: generateUUID() }));
  }
);
